import React, { useEffect, useRef, useState } from 'react';
import Swiper from 'react-id-swiper';
import helpers from 'utils/helpers';
import { Link, navigate } from 'gatsby';
import Img from 'img';

import s from './aside-tabs.module.scss';

export default function AsideTabs({ tabs, ...props }) {
  const tabNames = tabs.map(
    tab => (tab.type.includes('editor') ? "editor's picks" : tab.type)
    // eslint-disable-next-line function-paren-newline
  );
  const params = {
    slidesPerView: 1,
    spaceBetween: 10,
    width: 269,
    preloadImages: false
  };
  const swiper = useRef();
  const slideTo = idx => swiper && swiper.current.slideTo(idx);
  const [activeIndex, setActiveIndex] = useState(0);
  // eslint-disable-next-line no-return-assign
  const updateSwiper = mySwiper => (swiper.current = mySwiper);

  const handleResize = () => {
    clearTimeout(window.swiperResize);
    if (window.innerWidth < 1230) return null;
    window.swiperResize = setTimeout(() => {
      if (swiper && swiper.current) {
        swiper.current.update();
      }
    }, 50);
  };

  useEffect(() => {
    if (swiper && swiper.current) {
      swiper.current.on('slideChange', () => setActiveIndex(swiper.current.activeIndex));
    }
  }, [swiper]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <aside className={s.root}>
      <div className={s.tabButtons}>
        {tabNames.map((tab, idx) => {
          const active = idx === activeIndex;
          return (
            <button
              onClick={() => slideTo(idx)}
              className={`${s.tabButton} ${active ? s.active : ''}`}
              type="button"
              key={tab}
            >
              {tab}
            </button>
          );
        })}
      </div>
      <div className={s.swiper}>
        <Swiper getSwiper={updateSwiper} {...params}>
          {tabs.map(({ type, data }) => {
            return (
              <div key={type} className={s.tabWrapper}>
                {data.slice(0, 3).map(tab => {
                  const { date, featured_image } = tab.post_fields;
                  const dateString = helpers.getDateString(date);
                  const { slug } = tab;
                  return (
                    <article
                      className={s.tabArticle}
                      key={tab.page_title}
                      onClick={() => {
                        navigate(slug);
                      }}
                    >
                      <div className={s.articleImage}>
                        <Img src={featured_image || 'placeholder-dark'} className={s.img} />
                      </div>
                      <div className={s.articleContent}>
                        <div className={s.articleLink} title={tab.page_title}>
                          <h6
                            className={s.articleTitle}
                            dangerouslySetInnerHTML={{
                              __html:
                                tab.page_title.length > 32
                                  ? `${tab.page_title.substr(0, 32)}...`
                                  : tab.page_title
                            }}
                          />
                        </div>
                        <p className={s.date}>{dateString}</p>
                      </div>
                    </article>
                  );
                })}
              </div>
            );
          })}
        </Swiper>
      </div>
    </aside>
  );
}
